module.exports = __webpack_public_path__ + "93857972572f393096ba73f175bb96c5.ttf";